import { useRef, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, Chip } from "@mui/material";

export default function TagsAutocomplete({value, setValue, TAGS}) {
  const [inputValue, setInputValue] = useState("");

  const highlightedRef = useRef(null);

  return (
    <Autocomplete
      multiple
      options={TAGS}
      filterSelectedOptions
      openOnFocus={false}
      autoHighlight
      value={value}
      inputValue={inputValue}
      onChange={(event, newValue) => {
        setValue(newValue);
        setInputValue("");
        highlightedRef.current = null;
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onHighlightChange={(event, option) => {
        highlightedRef.current = option;
      }}
      renderTags={(value, getTagProps) =>
        value.map((opt, idx) => (
          <Chip key={opt} label={opt} {...getTagProps({ index: idx })} size="small"/>
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={(value ?? []).length === 0 ? "Type, ↑/↓, Enter or Tab" : undefined}
          onKeyDown={(event) => {
            if (event.key === "Tab" && inputValue) {
              event.preventDefault();

              let toSelect = highlightedRef.current;

              if (!toSelect) {
                toSelect = TAGS.find(
                  (option) =>
                    !value.includes(option) &&
                    option
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                );
              }

              if (toSelect) {
                const newValue = [...value, toSelect]
                setValue(newValue)
                setInputValue("")
                highlightedRef.current = null
              }
            }
          }}
        />
      )}
    />
  );
}